var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLoginFormBackground = function SvgLoginFormBackground(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "578px",
    height: "594px",
    viewBox: "0 0 578 594",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8AD95139-0CDD-4C3B-8116-E634693A240F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "34.0215177%",
    y1: "6.69872981%",
    x2: "65.9784823%",
    y2: "93.3012702%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004F45",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003F38",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BE9F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A087",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "7.88501682%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00274F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002C57",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "50.6325806%",
    x2: "48.0998236%",
    y2: "56.4895064%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005046",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003E37",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.5496087%",
    y1: "56.8470427%",
    x2: "39.60967%",
    y2: "44.3928265%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.1160558%",
    y1: "45.6137315%",
    x2: "100%",
    y2: "77.1257788%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7BF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD9C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50.8322208%",
    y2: "90.4223208%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.1160558%",
    y1: "44.2727532%",
    x2: "100%",
    y2: "85.4187229%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7BF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD9C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005046",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003E37",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.1042045%",
    y1: "33.3717299%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.2909411%",
    y1: "40.2757766%",
    x2: "98.513877%",
    y2: "110.137024%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7BF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD9C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.194540793,0.248472849 C5.87196174,17.6003089 9.05988272,30.980975 9.75830373,40.3904713 C13.8145181,43.69761 37.1770848,53.8239472 45.4215228,35.4654519 C41.2087393,23.5585249 38.543227,11.9010339 38.543227,6.89082245 C38.543227,3.55068151 25.7603316,1.33656497 0.194540793,0.248472849 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.3652549%",
    y1: "40.2757766%",
    x2: "80.8869782%",
    y2: "110.137024%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD7BF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD9C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.427544665,62.033931 C-0.832112622,71.924389 2.31118386,77.6818883 9.85743412,79.3064289 C11.6572084,81.7236669 22.6429838,97.8203194 43.2512325,102.301507 C63.8594813,106.782694 73.7112127,103.368713 76.4534927,97.8643581 C79.1957726,92.3600037 90.5406211,63.0282389 70.816094,26.375766 C57.6664092,1.94078406 43.4377089,-5.51644426 28.1299931,4.00408105 L3.42302049,24.1293005 L0.427544665,62.033931 Z",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "31.0495501%",
    cy: "7.34226988%",
    fx: "31.0495501%",
    fy: "7.34226988%",
    r: "76.4643789%",
    gradientTransform: "translate(0.310496,0.073423),scale(0.809932,1.000000),rotate(52.820893),translate(-0.310496,-0.073423)",
    id: "radialGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002C57",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00274F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.02735299,1.2345074 C-1.24710616,2.57364443 -1.55598146,22.9223528 3.58390575,24.1206961 C8.72379296,25.3190394 47.7442647,26.926894 58.7174661,24.1206961 C69.6906674,21.3144982 58.7174661,12.8944193 52.4465088,9.87441664 C46.1755515,6.85441403 19.1442701,-3.28714827 5.02735299,1.2345074 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.4541234%",
    y1: "0%",
    x2: "62.5458766%",
    y2: "100%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DC2A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009C82",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38.5057144%",
    y1: "6.69872981%",
    x2: "61.4942856%",
    y2: "93.3012702%",
    id: "linearGradient-22"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004F45",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003F38",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA9B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009B81",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Botwise---Logowanie---v1-Stany",
    transform: "translate(-742.000000, -171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ilustracja",
    transform: "translate(742.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(403.632414, 67.800483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.784462,28.8652377 C69.4727999,16.9683391 59.8853693,9.06961872 47.0036006,17.725148 C34.1218319,26.3806772 40.6900236,36.9891162 45.9600319,46.1477182 C51.2300402,55.3063202 56.1518055,64.9806959 47.2754434,73.6880211 C38.3990813,82.3953463 25.9381472,94.1125681 44.8562806,108.398922 C63.7744141,122.685276 67.5895837,134.43755 59.5649617,155.451128 C51.5403398,176.464705 78.500684,187.38461 102.212923,173.648408 C125.925161,159.912206 141.494226,138.077968 131.28751,125.285224 C121.080793,112.49248 100.190892,109.848238 103.875789,96.4501083 C107.560687,83.0519784 108.77562,61.6621562 93.9290515,51.3366439 C79.0824829,41.0111317 76.096124,40.7621363 72.784462,28.8652377 Z",
    id: "Path-4-Copy",
    fill: "url(#linearGradient-1)",
    transform: "translate(84.717832, 96.906970) rotate(-330.000000) translate(-84.717832, -96.906970) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7408052,41.0130804 C65.0547007,111.192218 72.0466233,168.975525 67.7165729,214.363001",
    id: "Path-10",
    stroke: "#E9FBF8",
    strokeWidth: 1.6911469,
    opacity: 0.100000001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(57.849694, 127.688041) rotate(-330.000000) translate(-57.849694, -127.688041) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(404.308873, 98.525670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.993565,46.2725403 C152.490791,28.9152696 146.080584,12.0153781 123.363253,13.5180808 C100.645923,15.0207835 101.233107,33.1285541 101.23071,48.4701577 C101.228313,63.8117614 100.405515,79.5480318 82.7438505,84.0300556 C65.0821856,88.5120793 40.6588461,94.1678154 54.2589078,125.882214 C67.8589695,157.596612 64.1079081,175.138511 38.5211435,195.702352 C12.9343789,216.266194 39.2257871,249.602169 79.4350482,249.59589 C119.644309,249.589612 135.444561,224.103393 131.829272,200.603859 C128.213984,177.104325 112.673333,166.676528 135.917373,146.271181 C159.161412,125.865834 169.755164,113.66636 158.433459,89.8909131 C147.111755,66.115466 143.496339,63.6298109 147.993565,46.2725403 Z",
    id: "Path-4",
    fill: "url(#linearGradient-2)",
    transform: "translate(95.693442, 131.510341) rotate(-345.000000) translate(-95.693442, -131.510341) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.709728,303.346818 C46.9960886,274.925691 54.3178567,243.065429 60.6750322,207.766031 C70.2107955,154.816936 102.646462,114.097457 105.38393,53.1517408",
    id: "Path-5",
    stroke: "#BCF0E8",
    strokeWidth: 2.02937636,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(72.046829, 178.249279) rotate(-345.000000) translate(-72.046829, -178.249279) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.6398833,328.960828 L57.7546156,559.393331 L91.5775535,559.393331 C97.5125526,481.001982 100.480052,430.44865 100.480052,407.733333 C100.480052,385.018017 101.802404,386.220575 104.447107,411.341009 C108.503336,497.268775 110.193852,546.619548 109.518655,559.393331 C119.035884,559.460697 130.310196,559.460697 143.341593,559.393331 C145.851709,467.690158 145.157406,413.41989 141.258685,396.582525 C137.359964,379.74516 129.964103,359.710803 119.071102,336.479454 L86.6504658,321.290473 L55.6398833,328.960828 Z",
    id: "Path-27",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6398833,339.56098 C64.0822856,340.678558 70.2545159,341.511128 74.1565743,342.058692 C80.0096619,342.880038 95.8063704,343.335329 102.156115,340.809836 C106.389278,339.126174 106.389278,336.20368 102.156115,332.042354 L78.7477557,325.916764 L55.6398833,331.043423 L55.6398833,339.56098 Z",
    id: "Path-29",
    fill: "url(#linearGradient-4)",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0193606,284.463817 C47.6559943,317.098375 48.5295019,333.415654 55.6398833,333.415654 C66.3054553,333.415654 80.4229285,340.309204 106.252946,333.415654 C123.472957,328.819954 145.720324,278.322334 172.995047,181.922793 C167.584633,153.37048 159.568329,137.06303 148.946135,133.000442 C138.323941,128.937854 124.172692,126.100916 106.492389,124.48963 L102.275101,137.666914 L70.8910167,130.910826 L60.8314231,137.666914 L41.3700975,188.349193 L53.0193606,284.463817 Z",
    id: "Path-21",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7430085,286.045496 L51.5134638,294.341134 C70.3733179,311.071015 85.9511665,322.57607 98.2470098,328.856301 C110.542853,335.136532 111.785721,329.403191 101.975613,311.656278 L56.1186718,281.963258 L52.7430085,286.045496 Z",
    id: "Path-23",
    fill: "url(#linearGradient-6)",
    opacity: 0.200000003
  }), /*#__PURE__*/React.createElement("g", {
    id: "APLA",
    transform: "translate(94.378494, 155.110927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4216146,-5.09881338e-15 L355.924466,-2.15585973e-15 C368.589055,1.25261659e-15 373.181541,1.31864665 377.811525,3.7947894 C382.441509,6.27093216 386.075148,9.90457101 388.551291,14.5345554 C391.027434,19.1645398 392.34608,23.7570258 392.34608,36.4216146 L392.34608,295.719636 C392.34608,308.384225 391.027434,312.976711 388.551291,317.606695 C386.075148,322.23668 382.441509,325.870319 377.811525,328.346461 C373.181541,330.822604 368.589055,332.141251 355.924466,332.141251 L36.4216146,332.141251 C23.7570258,332.141251 19.1645398,330.822604 14.5345554,328.346461 C9.90457101,325.870319 6.27093216,322.23668 3.7947894,317.606695 C1.31864665,312.976711 2.67756727e-15,308.384225 -4.60832111e-15,295.719636 L9.80984549e-16,36.4216146 C-5.69980273e-16,23.7570258 1.31864665,19.1645398 3.7947894,14.5345554 C6.27093216,9.90457101 9.90457101,6.27093216 14.5345554,3.7947894 C19.1645398,1.31864665 23.7570258,2.96255741e-15 36.4216146,-5.09881338e-15 Z",
    id: "Rectangle",
    fill: "#BCF0E8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 33.822938,
    y: 60.8812883,
    width: 189.746682,
    height: 2.02937628,
    rx: 1.01468814
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8376261,33.822938 L132.938975,33.822938 C133.499372,33.822938 133.953664,34.2772293 133.953664,34.8376261 C133.953664,35.3980229 133.499372,35.8523142 132.938975,35.8523142 L34.8376261,35.8523142 C34.2772293,35.8523142 33.822938,35.3980229 33.822938,34.8376261 C33.822938,34.2772293 34.2772293,33.822938 34.8376261,33.822938 Z",
    id: "Rectangle-Copy-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.417739,96.3953732 L42.9283416,96.3953732 C40.0495513,96.3953732 38.9913714,96.659249 37.9351026,97.2241478 C36.9570501,97.747216 36.1894689,98.5147972 35.6664007,99.4928497 C35.1015019,100.549119 34.8376261,101.607298 34.8376261,104.486089 L34.8376261,140.391982 C34.8376261,143.270772 35.1015019,144.328952 35.6664007,145.385221 C36.1894689,146.363274 36.9570501,147.130855 37.9351026,147.653923 C38.9913714,148.218822 40.0495513,148.482698 42.9283416,148.482698 L349.417739,148.482698 C352.296529,148.482698 353.354709,148.218822 354.410978,147.653923 C355.38903,147.130855 356.156611,146.363274 356.67968,145.385221 C357.244578,144.328952 357.508454,143.270772 357.508454,140.391982 L357.508454,104.486089 C357.508454,101.607298 357.244578,100.549119 356.67968,99.4928497 C356.156611,98.5147972 355.38903,97.747216 354.410978,97.2241478 C353.354709,96.659249 352.296529,96.3953732 349.417739,96.3953732 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2.02937628
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 60.8812883,
    cy: 122.439035,
    r: 5.41167007
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#FFFFFF",
    cx: 82.5279686,
    cy: 122.439035,
    r: 5.41167007
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#FFFFFF",
    cx: 104.174649,
    cy: 122.439035,
    r: 5.41167007
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#FFFFFF",
    cx: 125.821329,
    cy: 122.439035,
    r: 5.41167007
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#FFFFFF",
    cx: 147.46801,
    cy: 122.439035,
    r: 5.41167007
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    fill: "#FFFFFF",
    cx: 169.11469,
    cy: 122.439035,
    r: 5.41167007
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    fill: "#FFFFFF",
    cx: 190.76137,
    cy: 122.439035,
    r: 5.41167007
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    fill: "#FFFFFF",
    cx: 212.40805,
    cy: 122.439035,
    r: 5.41167007
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.417739,170.805837 L42.9283416,170.805837 C40.0495513,170.805837 38.9913714,171.069713 37.9351026,171.634611 C36.9570501,172.157679 36.1894689,172.925261 35.6664007,173.903313 C35.1015019,174.959582 34.8376261,176.017762 34.8376261,178.896552 L34.8376261,214.802446 C34.8376261,217.681236 35.1015019,218.739416 35.6664007,219.795685 C36.1894689,220.773737 36.9570501,221.541318 37.9351026,222.064387 C38.9913714,222.629285 40.0495513,222.893161 42.9283416,222.893161 L349.417739,222.893161 C352.296529,222.893161 353.354709,222.629285 354.410978,222.064387 C355.38903,221.541318 356.156611,220.773737 356.67968,219.795685 C357.244578,218.739416 357.508454,217.681236 357.508454,214.802446 L357.508454,178.896552 C357.508454,176.017762 357.244578,174.959582 356.67968,173.903313 C356.156611,172.925261 355.38903,172.157679 354.410978,171.634611 C353.354709,171.069713 352.296529,170.805837 349.417739,170.805837 Z",
    id: "Rectangle-Copy-9",
    stroke: "#FFFFFF",
    strokeWidth: 2.02937628
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 60.8812883,
    cy: 196.849499,
    r: 5.41167007
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#FFFFFF",
    cx: 82.5279686,
    cy: 196.849499,
    r: 5.41167007
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#FFFFFF",
    cx: 104.174649,
    cy: 196.849499,
    r: 5.41167007
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#FFFFFF",
    cx: 125.821329,
    cy: 196.849499,
    r: 5.41167007
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#FFFFFF",
    cx: 147.46801,
    cy: 196.849499,
    r: 5.41167007
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.417739,245.2163 L232.675024,245.2163 C229.796233,245.2163 228.738053,245.480176 227.681785,246.045075 C226.703732,246.568143 225.936151,247.335724 225.413083,248.313777 C224.848184,249.370046 224.584308,250.428225 224.584308,253.307016 L224.584308,289.212909 C224.584308,292.091699 224.848184,293.149879 225.413083,294.206148 C225.936151,295.184201 226.703732,295.951782 227.681785,296.47485 C228.738053,297.039749 229.796233,297.303625 232.675024,297.303625 L349.417739,297.303625 C352.296529,297.303625 353.354709,297.039749 354.410978,296.47485 C355.38903,295.951782 356.156611,295.184201 356.67968,294.206148 C357.244578,293.149879 357.508454,292.091699 357.508454,289.212909 L357.508454,253.307016 C357.508454,250.428225 357.244578,249.370046 356.67968,248.313777 C356.156611,247.335724 355.38903,246.568143 354.410978,246.045075 C353.354709,245.480176 352.296529,245.2163 349.417739,245.2163 Z",
    id: "Rectangle-Copy-11",
    stroke: "#FFFFFF",
    strokeWidth: 2.02937628
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAND",
    transform: "translate(238.701429, 141.984632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1437816,7.20728148 C24.1161576,0.800809053 34.6729479,-1.33468175 41.8141526,0.800809053 C52.5259597,4.00404526 51.3678057,23.9237511 47.3846948,26.2076398 C43.4015839,28.4915286 28.4627409,25.6630134 26.369083,13.1262956 C21.5829314,13.151751 16.1744976,13.151751 10.1437816,13.1262956 L10.1437816,7.20728148 Z",
    id: "Path-24",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-25",
    fill: "#004F45",
    points: "10.1437816 7.20728148 -3.07617829e-13 13.1262956 10.1437816 13.1262956"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.5897268,197.795092 C77.6654755,237.809675 79.0103363,263.239995 74.6243091,274.086054 C70.238282,284.932112 64.6150508,282.463637 57.7546156,266.680629 L70.5897268,197.795092 Z",
    id: "Path-22",
    fill: "url(#linearGradient-8)",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.550506,316.363623 C126.379641,316.24708 127.421173,316.473567 128.675104,317.043083 C129.292804,317.323633 143.498563,317.9829 145.802386,319.09941 C149.291029,320.790125 149.667514,323.013045 148.199834,323.939921 C146.839335,324.79911 139.707647,322.831392 140.24497,323.109217 C149.171155,327.724544 150.999288,330.53523 151.995426,334.498032 C154.043537,342.645756 148.157874,348.376301 141.886665,348.376301 C135.615456,348.376301 128.468762,346.795927 113.961597,328.59787 C104.290153,316.465833 108.153123,312.38775 125.550506,316.363623 Z",
    id: "Path-26",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5897268,129.327983 C55.3440719,132.173022 46.6918601,137.222557 44.6330911,144.476588 C41.5449377,155.357634 23.4211411,198.346946 28.4485804,255.543612 C30.9523637,279.378058 113.134667,333.415654 117.41587,333.415654 C121.697074,333.415654 129.92268,319.722743 129.92268,317.115538 C129.92268,314.508333 74.2893021,270.468492 66.6016503,265.073001 C68.0061979,254.203717 70.5897268,204.807706 70.5897268,197.795092",
    id: "Path-17",
    fill: "url(#linearGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5897268,129.327983 C55.3440719,132.173022 46.6918601,137.222557 44.6330911,144.476588 C41.5449377,155.357634 23.4211411,198.346946 28.4485804,255.543612 C30.9523637,279.378058 113.134667,333.415654 117.41587,333.415654 C121.697074,333.415654 129.92268,319.722743 129.92268,317.115538 C129.92268,314.508333 74.2893021,270.468492 66.6016503,265.073001 C68.0061979,254.203717 70.5897268,204.807706 70.5897268,197.795092",
    id: "Path-17-Copy",
    fillOpacity: 0.05,
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5897268,129.327983 L70.0735871,130.264486 C69.4515662,131.393066 69.7117666,132.803717 70.6954859,133.636124 C79.2361594,140.8631 87.4524962,144.476588 95.3444964,144.476588 C103.060226,144.476588 107.67436,139.686799 109.186898,130.107223 C109.445301,128.470661 108.888311,126.81103 107.694935,125.6617 L103.398973,121.524296 L103.398973,121.524296 L70.5897268,129.327983 Z",
    id: "Path-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Szyja",
    transform: "translate(60.831423, 88.937511)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-12)",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "GLOWA",
    transform: "translate(75.445034, 59.044574) rotate(1.000000) translate(-75.445034, -59.044574) translate(20.945034, 1.044574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-6",
    transform: "translate(21.984910, 10.485111)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-15)",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82131664,28.4815696 C10.2293332,38.5881149 44.4438005,68.8432895 66.1294473,60.8079621 C78.2438087,55.7012935 78.9326655,31.2076175 62.1311273,14.8514865 C45.3295891,-1.50464456 12.7379351,-6.53585669 -9.09064656,6.1573649 C-33.737626,23.9542765 -8.82610012,16.4016214 1.82131664,28.4815696 Z",
    fill: "#FFBC98",
    mask: "url(#mask-17)",
    transform: "translate(27.691685, 30.581480) rotate(-15.000000) translate(-27.691685, -30.581480) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.8193612,49.6234433 C91.6273927,52.4461115 91.1145839,54.2263776 89.2809348,54.9642416 C86.5304613,56.0710376 65.4688456,65.8399909 34.4875564,48.1113837 C38.1339619,60.0926449 38.4057117,66.2740425 37.080611,73.4301237 C34.9591424,70.9278012 29.8416187,66.3264565 25.6684096,69.0576125 C21.4952005,71.7887686 21.971303,75.5491348 22.4926767,80.2652029 C16.7518974,73.2378241 11.8334774,66.6999567 10.480192,54.9642416 C9.12690669,43.2285265 8.57060254,31.8902242 21.5290795,22.5465671 C29.4538529,12.084014 45.1378598,-5.42462512 74.4849566,1.62870684 C103.832053,8.68203879 110.824607,22.8792771 108.496173,34.6599899 C106.943883,42.5137985 101.051612,47.5016163 90.8193612,49.6234433 Z",
    id: "Path-14",
    fill: "url(#radialGradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2064996,77.5503362 C-0.743609561,61.9917847 -3.0979507,46.4332332 4.14347621,30.8746818",
    id: "Path-3",
    stroke: "#002C56",
    strokeWidth: 1.6911469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-28",
    transform: "translate(106.892981, 554.898054)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#02213F",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45.0801888,0.624372525 C-51.7148839,2.03545466 -52.0414927,23.477397 -46.6065088,24.7401212 C-41.1715249,26.0028454 0.089231993,27.697082 11.6924385,24.7401212 C23.2956451,21.7831604 11.2225803,11.3364218 6.18265488,8.41851333 C1.14272947,5.50060486 -30.1527761,-4.140209 -45.0801888,0.624372525 Z",
    fill: "#000000",
    opacity: 0.200000003,
    mask: "url(#mask-20)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.5094682,556.132561 C54.235009,557.471698 53.9261337,577.820407 59.0660209,579.01875 C64.2059081,580.217093 103.22638,581.824948 114.199581,579.01875 C125.172783,576.212552 113.755234,566.298448 108.988956,563.529312 C104.222677,560.760175 74.6263853,551.610906 60.5094682,556.132561 Z",
    id: "Path-28",
    fill: "#02213F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(244.521033, 473.651372) scale(-1, 1) translate(-244.521033, -473.651372) translate(157.521033, 365.151372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LISC",
    transform: "translate(126.227205, 83.427250) rotate(1.000000) translate(-126.227205, -83.427250) translate(80.727205, 0.927250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.043889,161.72896 C28.7481313,156.424342 18.2577992,149.544295 14.5728928,141.088818 C-5.95354849,93.9883421 9.72823795,30.8230718 55.5365644,2.8369394 C86.9124411,38.3803894 95.8019446,96.3643008 70.9221061,140.650655 C66.3148846,148.851554 58.0221456,155.877656 46.043889,161.72896 Z",
    id: "Path-19",
    fill: "url(#linearGradient-21)",
    transform: "translate(45.497701, 82.282950) rotate(4.000000) translate(-45.497701, -82.282950) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 1.6911469,
    opacity: 0.400000006,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "54.7530261 33.287435 45.0428428 79.5742455 34.2418119 131.060943"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LISC-Copy",
    transform: "translate(83.291887, 93.046570) scale(-1, 1) rotate(-330.000000) translate(-83.291887, -93.046570) translate(29.791887, 19.546570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4814388,139.26097 C39.8502995,134.76786 30.9567965,129.003441 27.8009298,121.967714 C10.221457,82.7758253 23.1284943,30.4449082 61.6576297,7.46442809 C88.3364895,37.1237691 96.1481166,85.2851059 75.3753411,121.901915 C71.5286611,128.682576 64.564027,134.468928 54.4814388,139.26097 Z",
    id: "Path-19",
    fill: "url(#linearGradient-22)",
    transform: "translate(53.645187, 73.362699) rotate(-19.000000) translate(-53.645187, -73.362699) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.8180768,
    y1: 33.4686913,
    x2: 69.4289807,
    y2: 140.88378,
    id: "Line-2",
    stroke: "#FFFFFF",
    strokeWidth: 1.6911469,
    opacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "KWIAT-Copy",
    transform: "translate(59.285733, 82.349760) rotate(-3.000000) translate(-59.285733, -82.349760) translate(21.285733, 6.349760)",
    fill: "#0AB99E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.4818762,151.726831 C40.7054391,104.200511 25.3172205,65.2334771 25.3172205,34.8257306 C22.9401752,38.6567887 17.3726835,70.9565996 67.2219763,151.726831 C69.2146314,151.804126 70.6345981,151.804126 71.4818762,151.726831 Z",
    id: "Path-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8173368,47.096176 C1.14273768,31.7642823 1.14051941,17.0575904 18.810682,2.97610005 C36.0998998,17.6853981 36.1021181,32.3920901 18.8173368,47.096176 Z",
    id: "Path-10",
    transform: "translate(18.669491, 25.036138) rotate(-15.000000) translate(-18.669491, -25.036138) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8357713,134.20196 C22.8957866,119.848925 21.9734641,110.481743 22.0688038,106.100414 C22.2118133,99.5284214 28.985912,91.7991134 35.9977805,91.6692074 C43.009649,91.5393014 47.1479734,95.6403302 45.337023,104.512409 C43.5260726,113.384488 39.8626537,117.789579 33.1981597,128.523258 C29.1972144,129.771951 26.4097516,131.664852 24.8357713,134.20196 Z",
    id: "Path-16-Copy-3",
    transform: "translate(33.912053, 112.934089) rotate(-443.000000) translate(-33.912053, -112.934089) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4967765,106.558798 C46.0495589,96.6255114 42.1293836,89.2632653 41.7362507,84.4720596 C41.1465514,77.285251 44.3790318,68.9806547 50.8324183,69.5163216 C57.2858049,70.0519885 64.9074986,76.3014986 65.3687787,84.0622121 C65.8300588,91.8229257 64.0344025,97.5966804 60.9047265,107.960575 C56.9352315,106.929798 54.4659149,106.462539 53.4967765,106.558798 Z",
    id: "Path-16-Copy",
    transform: "translate(53.554120, 88.726134) rotate(-317.000000) translate(-53.554120, -88.726134) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4050611,71.6063205 C31.4748123,64.7826425 30.3390407,58.8904227 29.9977462,53.9296611 C29.4858045,46.4885187 32.6512869,40.1730069 38.8736434,40.6380408 C45.096,41.1030747 50.2323929,49.1131021 49.4848695,59.0172235 C48.7373461,68.9213449 49.1519983,70.2087015 44.2697139,81.8002838 C40.4478916,80.7873308 36.8263406,77.3893431 33.4050611,71.6063205 Z",
    id: "Path-16-Copy-2",
    transform: "translate(39.750730, 61.207086) rotate(-330.000000) translate(-39.750730, -61.207086) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0023347,93.99981 C15.4226844,89.03076 14.5519294,84.7298836 14.3900698,81.0971808 C14.1472805,75.6481267 17.2854427,70.9547419 23.0511899,71.1772919 C28.8169371,71.399842 33.3378413,77.1780872 32.3335935,84.4579846 C31.3293458,91.7378821 31.6742669,92.6743818 26.7762195,101.271007 C23.2576034,100.60075 19.9996418,98.1770177 17.0023347,93.99981 Z",
    id: "Path-16-Copy-4",
    transform: "translate(23.425423, 86.220347) scale(1, -1) rotate(-105.000000) translate(-23.425423, -86.220347) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1049977,65.4467616 C10.013321,61.3548004 8.90414633,57.8873274 8.77747361,55.0443427 C8.58746454,50.7798656 12.3931196,47.41406 17.197909,47.5995184 C22.0026983,47.7849767 27.4998794,52.8158383 26.6464369,58.5105436 C25.7929944,64.2052489 24.3358908,64.4383615 20.2342939,71.1557974 C17.3033238,70.6244061 14.5935584,68.7213941 12.1049977,65.4467616 Z",
    id: "Path-16-Copy-5",
    transform: "translate(17.752689, 59.374002) scale(1, -1) rotate(-105.000000) translate(-17.752689, -59.374002) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.4859802,137.997587 L151.774548,137.997587 C153.26894,137.997587 154.480383,139.20903 154.480383,140.703422 C154.480383,140.848019 154.468793,140.992382 154.445723,141.135127 L144.576729,202.199527 C143.279224,210.227837 136.348267,216.128574 128.215784,216.128574 L68.0447443,216.128574 C59.912261,216.128574 52.9813042,210.227837 51.6837995,202.199527 L41.8148056,141.135127 C41.5763815,139.659878 42.5790262,138.270671 44.0542752,138.032247 C44.1970197,138.009177 44.3413836,137.997587 44.4859802,137.997587 Z",
    id: "Rectangle",
    fill: "#E2E5EE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(320.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-23)",
    cx: 50.6473615,
    cy: 50.6473615,
    r: 50.6473615
  }), /*#__PURE__*/React.createElement("g", {
    id: "zoom-2",
    transform: "translate(30.495001, 29.425001)",
    stroke: "#FFFFFF",
    strokeWidth: 7.70400068
  }, /*#__PURE__*/React.createElement("line", {
    x1: 40.228342,
    y1: 39.7215378,
    x2: 28.4583414,
    y2: 27.9515372,
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeLinecap: "square",
    cx: 16.6883409,
    cy: 16.1815367,
    r: 16.0500008
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(19.000000, 365.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-23)",
    cx: 49.7006772,
    cy: 49.7006772,
    r: 49.7006772
  }), /*#__PURE__*/React.createElement("g", {
    id: "layers-3",
    transform: "translate(22.049999, 20.999999)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0239147,39.9683797 L48.5238537,36.7797827 L29.5418568,47.7907586 C28.4067165,48.4493726 27.0133673,48.4493726 25.8782271,47.7907586 L6.90084665,36.7750935 L1.39616912,39.9683797 C1.10871476,40.1354139 0.931349969,40.4460299 0.931349969,40.7824098 C0.931349969,41.1187897 1.10871476,41.4294057 1.39616912,41.5964399 L27.248395,56.6016025 C27.5321801,56.766256 27.8805174,56.766256 28.1643025,56.6016025 L54.0165284,41.5964399 C54.3039828,41.4294057 54.4813475,41.1187897 54.4813475,40.7824098 C54.4813475,40.4460299 54.3039828,40.1354139 54.0165284,39.9683797 L54.0239147,39.9683797 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0239147,27.3683803 L48.5238537,24.1797832 L29.5418568,35.1907591 C28.4067165,35.8493731 27.0133673,35.8493731 25.8782271,35.1907591 L6.90084665,24.1750941 L1.39616912,27.3683803 C1.10871476,27.5354145 0.931349969,27.8460305 0.931349969,28.1824104 C0.931349969,28.5187902 1.10871476,28.8294062 1.39616912,28.9964404 L27.248395,44.0016031 C27.5321801,44.1662566 27.8805174,44.1662566 28.1643025,44.0016031 L54.0165284,28.9964404 C54.3039828,28.8294062 54.4813475,28.5187902 54.4813475,28.1824104 C54.4813475,27.8460305 54.3039828,27.5354145 54.0165284,27.3683803 L54.0239147,27.3683803 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0165284,14.9709028 L28.1643025,0.147092834 C27.8805174,-0.0155706602 27.5321801,-0.0155706602 27.248395,0.147092834 L1.39616912,14.9709028 C1.10871476,15.1359182 0.931349969,15.4427801 0.931349969,15.7750945 C0.931349969,16.1074089 1.10871476,16.4142708 1.39616912,16.5792862 L27.248395,31.4030962 C27.5321801,31.5657597 27.8805174,31.5657597 28.1643025,31.4030962 L54.0165284,16.5792862 C54.3039828,16.4142708 54.4813475,16.1074089 54.4813475,15.7750945 C54.4813475,15.4427801 54.3039828,15.1359182 54.0165284,14.9709028 L54.0165284,14.9709028 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-2",
    transform: "translate(437.004855, 425.694431)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-23)",
    cx: 49.8252432,
    cy: 49.8252432,
    r: 49.8252432
  }), /*#__PURE__*/React.createElement("g", {
    id: "password",
    transform: "translate(29.664000, 23.175000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.959496,21.724978 L34.6315632,21.724978 L34.6315632,13.5781113 C34.6315632,6.07912749 28.6680713,0 21.3117312,0 C13.9553911,0 7.99189919,6.07912749 7.99189919,13.5781113 L7.99189919,21.724978 L2.6639664,21.724978 C1.19269838,21.724978 0,22.9408035 0,24.4406003 L0,48.8812006 C0,50.3809974 1.19269838,51.5968229 2.6639664,51.5968229 L39.959496,51.5968229 C41.430764,51.5968229 42.6234624,50.3809974 42.6234624,48.8812006 L42.6234624,24.4406003 C42.6234624,22.9408035 41.430764,21.724978 39.959496,21.724978 Z M29.3036304,21.724978 L13.319832,21.724978 L13.319832,13.5781113 C13.319832,9.078721 16.8979271,5.43124451 21.3117312,5.43124451 C25.7255352,5.43124451 29.3036304,9.078721 29.3036304,13.5781113 L29.3036304,21.724978 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2.38712256,578.91234 L574.172343,578.91234 C575.250547,578.91234 576.124604,579.786397 576.124604,580.864602 C576.124604,581.942806 575.250547,582.816864 574.172343,582.816864 L2.38712256,582.816864 C1.30891809,582.816864 0.43486066,581.942806 0.43486066,580.864602 C0.43486066,579.786397 1.30891809,578.91234 2.38712256,578.91234 Z",
    id: "Rectangle",
    fill: "#B4EFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.268383,590.750368 L497.313838,590.750368 C498.392043,590.750368 499.2661,591.624426 499.2661,592.70263 C499.2661,593.780834 498.392043,594.654892 497.313838,594.654892 L299.268383,594.654892 C298.190179,594.654892 297.316122,593.780834 297.316122,592.70263 C297.316122,591.624426 298.190179,590.750368 299.268383,590.750368 Z",
    id: "Rectangle-Copy",
    fill: "#B4EFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.827739,590.750368 L288.468176,590.750368 C289.546381,590.750368 290.420438,591.624426 290.420438,592.70263 C290.420438,593.780834 289.546381,594.654892 288.468176,594.654892 L268.827739,594.654892 C267.749535,594.654892 266.875477,593.780834 266.875477,592.70263 C266.875477,591.624426 267.749535,590.750368 268.827739,590.750368 Z",
    id: "Rectangle-Copy-2",
    fill: "#B4EFE6"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLoginFormBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/login_form_background.5d3ce2a992f08fa7d533f3fcfd42e4d9.svg";